interface LogoProps {
  className?: string;
}

/** Kanata wordmark. Uses currentColor so it can render brand-green or white. */
export function Logo({ className = "h-6 w-auto text-brand" }: LogoProps) {
  return (
    <svg
      viewBox="0 0 347.3 56.58"
      fill="currentColor"
      role="img"
      aria-label="Kanata Indonesia"
      className={className}
    >
      <path d="M31.41,55.31,13,30V55.31H0V0H13V26.73L30.24,1.27H45.75L26.44,27.7,48.87,55.31Z" />
      <path d="M91.88,55.31v-7c-5.17,5.85-10.34,8.29-17.95,8.29-15.8,0-27.22-11.8-27.22-28.09C46.71,12,58.23,0,74.22,0,82,0,87.39,2.54,91.88,8.49V1.27h11.9v54ZM75.59,11.9c-9.27,0-15.8,7-15.8,16.88,0,9.46,6.54,15.9,16,15.9,9.85,0,15.71-7,15.71-16C91.49,18.83,84.86,11.9,75.59,11.9Z" />
      <path d="M146.36,55.31V28.88c0-14.44-3.9-17-10.34-17a10.89,10.89,0,0,0-9.56,5c-1.66,2.63-2.15,5.76-2.15,13V55.31h-13v-54h12V6.44C128.12,1.85,132.41,0,138.55,0c7.51,0,13.36,2.73,16.88,7.8,2.93,4.19,3.9,8.88,3.9,18.53v29Z" />
      <path d="M210.25,55.31v-7c-5.17,5.85-10.34,8.29-17.95,8.29-15.8,0-27.22-11.8-27.22-28.09C165.08,12,176.6,0,192.59,0c7.8,0,13.17,2.54,17.66,8.49V1.27h11.9v54ZM194,11.9c-9.27,0-15.8,7-15.8,16.88,0,9.46,6.54,15.9,16,15.9,9.85,0,15.71-7,15.71-16C209.86,18.83,203.23,11.9,194,11.9Z" />
      <path d="M335.4,55.31v-7c-5.17,5.85-10.34,8.29-17.95,8.29-15.8,0-27.22-11.8-27.22-28.09C290.24,12,301.75,0,317.75,0c7.8,0,13.17,2.54,17.66,8.49V1.27h11.9v54ZM319.11,11.9c-9.27,0-15.8,7-15.8,16.88,0,9.46,6.54,15.9,16,15.9,9.85,0,15.71-7,15.71-16C335,18.83,328.38,11.9,319.11,11.9Z" />
      <rect x="250.92" width="10.55" height="56.58" />
      <rect
        x="250.92"
        width="10.55"
        height="56.58"
        transform="translate(284.48 -227.9) rotate(90)"
      />
    </svg>
  );
}
